import type {
  AddAdditionalInterestBlockReason,
  RemoveAdditionalInterestBlockReason,
  AdditionalInterestValidationBlockReason,
  EditOrReplaceAdditionalInterestBlockReason,
} from "@covertree/agent-portal-graphql";
import type { AdditionalInterestType } from "@covertree/new-business-graphql";
import type { AdditionalInterestFormData } from "@covertree/features";

import type { PolicyDetailsContentProps } from "../../types";

export type { AdditionalInterestFormData };

export type ModalMode = "add" | "edit" | "replace" | null;

export enum DefaultErrors {
  NotKnownError = "NotKnownError",
}

export type SuccessModalData = {
  isRenewalActive: boolean;
  isOfferSent: boolean;
};

export type MutationBlockReason =
  | DefaultErrors
  | AddAdditionalInterestBlockReason
  | AdditionalInterestValidationBlockReason
  | EditOrReplaceAdditionalInterestBlockReason
  | RemoveAdditionalInterestBlockReason;

export interface UseAdditionalInterestFormParams {
  policy: PolicyDetailsContentProps["policy"];
  validationReason: AdditionalInterestValidationBlockReason | null;
}

export interface AdditionalInterestFormModalProps {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly onSubmit: (data: AdditionalInterestFormData) => void;
  readonly mode: Exclude<ModalMode, null>;
  readonly isSubmitting?: boolean;
  readonly selectedInterest?: AdditionalInterestFormData | null;
  readonly interestsCountByType: Record<AdditionalInterestType, number>;
  readonly isTenantPolicy?: boolean;
}
